"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _constants = require("../constants");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ArrowSvg = function ArrowSvg(_ref) {
  var width = _ref.width,
    height = _ref.height,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    className: className,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.44836 6.5L6.27595 1.5M6.27595 1.5L11.1035 6.5M6.27595 1.5L6.27595 15.5",
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var Arrow = (0, _styledComponents["default"])(ArrowSvg).withConfig({
  displayName: "arrow__Arrow"
})(["margin-right:5px;path{stroke:", ";}", ""], function (_ref2) {
  var color = _ref2.color;
  return color;
}, function (_ref3) {
  var rotate = _ref3.rotate;
  return rotate && (0, _styledComponents.css)(["transform:rotate(", "deg);"], rotate);
});
Arrow.displayName = 'Arrow';
var defaultProps = {
  width: 13,
  height: 17,
  color: _constants.colors.darkGrey,
  rotate: 90
};
Arrow.defaultProps = defaultProps;
var _default = Arrow;
exports["default"] = _default;